export const isIos = () => /iPhone|iPad|iPod/i.test(navigator.userAgent);
